import { Box, Button, Grid } from '@mui/material';
import { Link, useRouteError } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '80vh' }}>
        <Grid item>
          <>An error has occurred :(</>
        </Grid>
        <Grid item>
          <Button variant="contained" component={Link} to={'/'} color="primary">
            Home
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
